export default __webpack_public_path__ + "static/media/yellow-umbrella.28d67ebe.png";